import backendAxios from '../utils/backendAxios';
import adminAxios from '../utils/adminAxios';

// ===== Usuario (cliente / proveedor) — chat con el superadministrador =====

export const getMiSoporte = async () => {
  try {
    const res = await backendAxios.get('/api/support/mine');
    return { ok: true, chat: res.data };
  } catch (e) {
    return { ok: false, error: 'No se pudo cargar el chat de soporte' };
  }
};

// Mensaje con archivos (imágenes/PDF) en multipart; sin archivos, el JSON de siempre.
const formularioConArchivos = (content, archivos) => {
  const formData = new FormData();
  formData.append('content', content || '');
  archivos.forEach((archivo) => formData.append('adjuntos', archivo));
  return formData;
};
const CABECERAS_MULTIPART = { headers: { 'Content-Type': 'multipart/form-data' } };

export const enviarMensajeSoporte = async (content, archivos = []) => {
  try {
    const res = archivos.length > 0
      ? await backendAxios.post('/api/support/mine', formularioConArchivos(content, archivos), CABECERAS_MULTIPART)
      : await backendAxios.post('/api/support/mine', { content });
    return { ok: true, message: res.data };
  } catch (e) {
    return { ok: false, error: e.response?.data?.msg || 'No se pudo enviar el mensaje' };
  }
};

// ===== Admin (panel) — conversaciones de soporte =====

export const getSoporteChats = async () => {
  try {
    const res = await adminAxios.get('/api/support');
    return { ok: true, chats: res.data };
  } catch (e) {
    return { ok: false, error: 'No se pudieron cargar las conversaciones' };
  }
};

export const getSoporteChat = async (userId) => {
  try {
    const res = await adminAxios.get(`/api/support/${userId}`);
    return { ok: true, chat: res.data };
  } catch (e) {
    return { ok: false, error: e.response?.data?.msg || 'No se pudo cargar la conversación' };
  }
};

// El admin ya tiene abierta la conversación cuando llega un mensaje: se marca leída en el
// servidor para que el badge del menú no la cuente. El fallo no se muestra (es solo el conteo).
export const marcarSoporteLeido = async (userId) => {
  try {
    await adminAxios.patch(`/api/support/${userId}/read`);
    return { ok: true };
  } catch (e) {
    return { ok: false };
  }
};

export const responderSoporte = async (userId, content, archivos = []) => {
  try {
    const res = archivos.length > 0
      ? await adminAxios.post(`/api/support/${userId}/message`, formularioConArchivos(content, archivos), CABECERAS_MULTIPART)
      : await adminAxios.post(`/api/support/${userId}/message`, { content });
    return { ok: true, message: res.data };
  } catch (e) {
    return { ok: false, error: e.response?.data?.msg || 'No se pudo enviar la respuesta' };
  }
};
